import 'select2';
import '../../../../../../web/bundles/ddfactorycore/assets/main.js';

export default function form() {
    $('select').each(function () {
        $(this).select2({
            minimumResultsForSearch: Infinity,
            placeholder: function () {
                $(this).data('placeholder');
            }
        });
    });


};


// WEBPACK FOOTER //
// ./app/Resources/assets/group/js/modules/form.js